module.exports = __webpack_public_path__ + "static/img/footer_icon_wechat_green.acdb0b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer_icon_wechat_green.png
// module id = 1TSE
// module chunks = 32